import {
  ERR_PASSWORD_CONFIRM,
  ERR_VALIDATION_ADDRESS,
  ERR_VALIDATION_EMAIL,
  ERR_VALIDATION_TEXT,
} from "constants/messages";
import phone from "phone";

export const checkEmail = (email = "") => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const checkPhone = (phoneNumber = "") => {
  return phone(phoneNumber)?.isValid ?? false;
};

export const checkValid = (type = "", value = "") => {
  if (type === "email") {
    return checkEmail(value);
  }
  if (type === "address") {
    return Boolean(value?.id);
  }
  return Boolean(value);
};

export const getValidationMessage = (type = "", name = "") => {
  if (type === "email") {
    return ERR_VALIDATION_EMAIL.LONG;
  }
  if (type === "email") {
    return ERR_VALIDATION_ADDRESS.LONG;
  }
  if (name === "password_confirm") {
    return ERR_PASSWORD_CONFIRM.LONG;
  }
  return ERR_VALIDATION_TEXT.LONG;
};

export const readableToSnake = (str = "") =>
  String(str).toLowerCase().replace(/[^\w]/g, "_");
